import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormFlow, FormFlowState, PgFormField, PgFormGroup, PgFormLayout } from '../../../models/form.model';
import { ConfigFormLayoutGroupField } from '../../../models/config.resources.model';
import { StepFormBase } from '../step-form-base';
import { DataService } from '../../../services/data.service';
import { EnvironmentService } from '../../../services/environment.service';
import { LocalizationService } from '../../../services/localization.service';
import { NotificationsService } from '../../../services/notifications.service';
import { OptionMapsService } from '../../../services/option-maps.service';
import { PGUtilities } from '../../../utilities/pg-utilities';
import { AuthService } from '../../../services/auth.service';
import { ConfigService } from '../../../services/config.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-forms-experience',
    templateUrl: './forms-experience.component.html',
    styleUrls: ['./forms-experience.component.scss'],
    standalone: false
})
export class FormsExperienceComponent extends StepFormBase {

    constructor(protected optionMapsService:OptionMapsService, protected localizationService:LocalizationService, protected dataService:DataService, protected authService:AuthService, protected router:Router, protected route:ActivatedRoute, protected environmentService:EnvironmentService, protected configService:ConfigService, protected notificationsService:NotificationsService, private modalService:NgbModal) {
        super(optionMapsService, localizationService, dataService, authService, router, route, environmentService, configService, notificationsService);
    }

    formId = 'experience';
    resourceId = 'Experience';

    @Input() typeFilter:string;

    protected getDraftResourceId(): string {
        return this.resourceId + (this.typeFilter ? '~' + this.typeFilter.charAt(0).toUpperCase() + this.typeFilter.substring(1) : '')
    }

    // TODO: per qualche motivo, carico qua staticamente tutti i contenuti delle select invece di usare il campo resource
    private _supplierOptions:Array<{ value:string, text: string, order?: number, category?: string }> = null;

    private _paymentMethodOptions:Array<{ value:string, text: string }> = [{
        value: 'contanti',
        text: 'forms-experience.options.payment-method.contanti'
    }, {
        value: 'bancomat',
        text: 'forms-experience.options.payment-method.bancomat'
    }, {
        value: 'carta_di_credito',
        text: 'forms-experience.options.payment-method.carta-di-credito'
    }]

    private _bookingDeadlineOptions:Array<{ value:string, text: string }> = [{
        value: '1',
        text: 'forms-experience.options.booking-deadline.1h'
    }, {
        value: '4',
        text: 'forms-experience.options.booking-deadline.4h'
    }, {
        value: '12',
        text: 'forms-experience.options.booking-deadline.12h'
    }, {
        value: '24',
        text: 'forms-experience.options.booking-deadline.1d'
    }, {
        value: '48',
        text: 'forms-experience.options.booking-deadline.2d'
    }, {
        value: '96',
        text: 'forms-experience.options.booking-deadline.4d'
    }, {
        value: '168',
        text: 'forms-experience.options.booking-deadline.1w'
    }]

    private _bookingNotificationOptions:Array<{ value:string, text: string }> = [{
        value: 'user',
        text: 'forms-experience.options.booking-notification.user'
    }, {
        value: 'supplier',
        text: 'forms-experience.options.booking-notification.supplier'
    }, {
        value: 'both',
        text: 'forms-experience.options.booking-notification.both'
    }]

    private _categoryItaliaOptions:Array<{ value: string, text: string }> = []

    _typeOptions:Array<{ value: string, text: string }> = null;
    _typeDefault:string = null;

    _currencyOptions:Array<{ value:string, text: string }> = null;
    _currencyDefault:string = null;

    ngOnChanges() {
        this._categoryItaliaOptions.splice(0)
        
        let _categoryItaliaValues = this.environmentService.environment.CategoryItaliaValues?.event;

        if(_categoryItaliaValues != null) {
            for(let _item of _categoryItaliaValues) {
                this._categoryItaliaOptions.push({ value: _item, text: _item })
            }
        }

        this._typeOptions = this.optionMapsService.getResourceFieldOptionMap('Experience', 'type')
        this._typeDefault = 'activity'

        if(this.typeFilter != null) {
            this._typeDefault = this.typeFilter
        }

        this._currencyOptions = this.optionMapsService.getFixedOptionMap('*', 'currency')
        this._currencyDefault = this.environmentService.getDefaultCurrency();

        super.ngOnChanges()
    }

    private _loadSupplierOptions() {
        return new Promise<null>((resolve, reject) => {
            this._supplierOptions.splice(0)

            let _supplierResources = ['Host','Eatery','ExperienceSupplier'];
            let _reqNum = _supplierResources.length;
    
            for(let i = 0; i < _supplierResources.length; i++) {
                let _resource = _supplierResources[i];
    
                this.dataService.getResourceData(_resource, { limit: 1000 }, null, null, 'public').subscribe((dataPublished) => {
                    this.dataService.getResourceData(_resource, { limit: 1000, filter: [{ field: 'published', operator: '!=', value: [true] }] }).subscribe((dataUnpublished) => {
                        for(let _list of [dataPublished, dataUnpublished]) {
                            for(let _item of _list) {
                                let _text = _item.name;
                                if(!_item.published) {
                                    _text += '<small class="text-muted"> (' + this.localizationService.translate('forms-experience.supplier-unpublished') + ')</small>'
                                }
    
                                this._supplierOptions.push({ value: _resource + '_' + _item.id, text: _text, order: i, category: this.localizationService.translateResource(_resource)  })
                            }
                        }
        
                        this._supplierOptions.sort((a, b) => {
                            if(a.order != b.order) {
                                if(a.order < b.order) return -1;
                                else if(a.order > b.order) return 1;
                            }
                            else {
                                let _aText = a.text.toLowerCase();
                                let _bText = b.text.toLowerCase();

                                if(_aText < _bText) return -1;
                                else if(_aText > _bText) return 1;
                                else return 0;
                            }
                        })
        
                        _reqNum--;
                        if(_reqNum <= 0) {
                            resolve(null)
                        }
                    }, () => {
                        _reqNum--;
                        if(_reqNum <= 0) {
                            resolve(null)
                        }
                    })
                })
            }
        })
    }

    initData() {
        return new Promise<null>((resolve, reject) => {
            for(let _cOption of this._paymentMethodOptions) {
                _cOption.text = this.localizationService.translate(_cOption.text)
            }

            for(let _cOption of this._bookingDeadlineOptions) {
                _cOption.text = this.localizationService.translate(_cOption.text)
            }

            for(let _cOption of this._bookingNotificationOptions) {
                _cOption.text = this.localizationService.translate(_cOption.text)
            }

            this._supplierOptions = [];

            if(this.viewOnly) {
                resolve(null)
            }
            else {
                this._loadSupplierOptions().then(() => {
                    resolve(null)
                })
            }
        })
    }
    

    createFormFlow() {
        let _phoneWarnMessage = this.localizationService.translate('forms-' + this.formId + '.warning.phone-sms');

        let _phoneWarnIf = '($value != null && /^\\+/.test($value) && !/^\\+[39|33|34|44|49|1]/.test($value) ? "' + _phoneWarnMessage + '" : null)'

        let _cPaymentTooltip = '';
        let _cPaymentOptions = this.optionMapsService.getResourceFieldOptionMap('Experience', 'payment')
        for(let _cOption of _cPaymentOptions) {
            if(_cPaymentTooltip != '') _cPaymentTooltip += ','
            _cPaymentTooltip += '"RESOURCES.' + this.resourceId + '.fields.payment-' + _cOption.value + '.tooltip"';
        }

        _cPaymentTooltip = '(service) => { let _retVal = ""; for(let _cTransl of [' + _cPaymentTooltip + ']) { _retVal += service.translate(_cTransl) + "<br/>" }; return _retVal; }'

        let _cStates:{ [name:string]: FormFlowState } = {
            'dati_generali': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'languages', tooltip: 'auto', required: true }),
                    new PgFormField({ label: null, type: 'split', name: 'split_0' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'type', options: this._typeOptions, default: this._typeDefault, readonly: true, required: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'title@ExperienceTranslation', required: true, locale: true, maxLength: 100 }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'supplier', options: this._supplierOptions, tooltip: 'auto', required: true }, null, [{ 
                        icon: 'fa-regular fa-plus', 
                        label: 'RESOURCES.' + this.resourceId + '.fields.supplier.action_create',
                        run: () => { 
                            this._createSupplier()
                         }
                    }]),
                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'target', required: true, tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'tags', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'info', name: 'images_rights', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'cover', tooltip: 'auto', required: true,
                        fileOptions: { 
                            imageRatio: { width: 4, height: 3 } 
                        } 
                    }),
                    new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'flyer', required: false }),
                    new PgFormField({ label: 'auto', type: 'phone', name: 'phone', warnIf: _phoneWarnIf }),
                    new PgFormField({ label: 'auto', type: 'email', name: 'email' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'website' }),
                    new PgFormField({ label: 'auto', type: 'social', name: 'social' }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'online', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'poi_id', resource: 'Poi', resourceSemantic: '{{id}} - {{name}}', resourceMode: 'public' }),
                    new PgFormField({ label: 'auto', type: 'location', name: 'geolocation', readonlyIf: '$form.poi_id', 
                        slaves: {
                            'country': 'country',
                            'region': 'region',
                            'province': 'province',
                            'city': 'city',
                            'locality': 'locality',
                            'address': 'address',
                            'zipcode': 'zipcode',
                            'timezone': 'timezone'
                        } 
                    }),
                    new PgFormField({ label: 'auto', type: 'info', name: 'geolocation_missing', tooltip: 'auto', infoType: 'warning' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'location_description@ExperienceTranslation', locale: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'country', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'region', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'province', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'city', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'locality', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'address', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'zipcode', readonly: true }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'timezone', readonly: true, default: 'Europe/Rome' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'group_id' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'priority', default: 5, required: true }),
                ])
            },
            'descrizione': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'select', name: 'category', required: true,
                        optionsFilter: [
                            { field: 'type', operator: '==', value: [ '{{$form.type}}' ]}
                        ]
                    }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'subcategory',
                        optionsFilter: [
                            { field: 'category', operator: '==', value: [ '{{$form.category}}' ]}
                        ]
                    }),
                    new PgFormField({ label: null, type: 'split', name: 'category_split' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'secondary_categories', multi: true,
                        optionsFilter: [
                            { field: 'type', operator: '==', value: [ '{{$form.type}}' ]},
                            { field: 'value', operator: '!=', value: [ '{{$form.category}}' ]}
                        ]
                    }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'category_italia', options: this._categoryItaliaOptions }),
                    new PgFormField({ label: 'auto', type: 'html', name: 'short_description@ExperienceTranslation', required: true, locale: true, maxLength: 3200 }),
                    new PgFormField({ label: 'auto', type: 'html', name: 'description@ExperienceTranslation', locale: true, tooltip: 'auto', maxLength: 5000 }),
                    new PgFormField({ label: 'auto', type: 'html', name: 'whats_included@ExperienceTranslation', locale: true, tooltip: 'auto', maxLength: 1000 }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'tour_product_id', resource: 'TourProduct' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'parent', tooltip: 'auto', resource: 'Experience~Event' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'difficulty' }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'stroller_friendly' }), 
                    new PgFormField({ label: 'auto', type: 'select', name: 'physical_accessibility' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'cognitive_accessibility' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'blindness_accessibility' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'deafness_accessibility' }),
                    new PgFormField({ label: 'auto', type: 'text', name: 'accessibility_description@ExperienceTranslation', locale: true, tooltip: 'auto' }),
                ])
            },
            'disponibilita': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'select', name: 'currency', options: this._currencyOptions, default: this._currencyDefault, required: true }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'bookable', default: false }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'booking', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'open_event', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'price_on_request', tooltip: 'auto', default: false }),
                    new PgFormField({ label: 'auto', type: 'float', name: 'price_on_request_from' }),
                    new PgFormField({ label: 'auto', type: 'info', name: 'payment_not_applicable', tooltip: 'auto' }), 

                    // questi campi vengono messi in dei gruppi
                    new PgFormField({ label: 'auto', type: 'timetable-event', name: 'availability_event', multi: true, requiredIf: '$form.type == "event"' }),
                    new PgFormField({ label: 'auto', type: 'timetable-days', name: 'availability_package', multi: true }),
                    new PgFormField({ label: 'auto', type: 'timetable-slots', name: 'availability_activity', multi: true, locale: true }),

                    new PgFormField({ label: 'auto', type: 'tickets-experience', name: 'tickets', locale: true, requiredIf: '$form.bookable' }), 

                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'payment', tooltip: _cPaymentTooltip, requiredIf: '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'iban', requiredIf: '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0 && tryParseJSON($form.payment).indexOf(\'bonifico\') != -1' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'swift', requiredIf: '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0 && tryParseJSON($form.payment).indexOf(\'bonifico\') != -1' }),
                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'payment_method', options: this._paymentMethodOptions, requiredIf: '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0 && tryParseJSON($form.payment).indexOf(\'sul_posto\') != -1' }),

                    new PgFormField({ label: 'auto', type: 'string', name: 'meeting_point_description@ExperienceTranslation', locale: true }),
                    new PgFormField({ label: 'auto', type: 'location', name: 'meeting_point' }),
                    
                    // gli altri campi a partire da qui vengono messi alla fine
                    // NB: parametrizzato per installazione min max partecipanti e cancellation_deadline tramite CustomFormConfig
                    new PgFormField({ label: 'auto', type: 'slider', min: 1, max: 5, name: 'minimum_guaranteed', default: 1, tooltip: 'auto', requiredIf: '$form.bookable' }),
                    new PgFormField({ label: 'auto', type: 'slider', min: 3, max: 15, name: 'maximum_participants', default: 10, tooltip: 'auto', requiredIf: '$form.bookable' }),

                    new PgFormField({ label: 'auto', type: 'survey', name: 'survey', locale: true }),

                    new PgFormField({ label: 'auto', type: 'boolean', name: 'overbooking', default: false, tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'instant_confirmation', default: false, tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'booking_deadline', options: this._bookingDeadlineOptions, default: 12, tooltip: 'auto', requiredIf: '$form.bookable' }),
                    new PgFormField({ label: 'auto', type: 'slider', min: 1, max: 30, name: 'cancellation_deadline', default: 7, tooltip: 'auto', requiredIf: '$form.bookable' }),
                    new PgFormField({ label: 'auto', type: 'integer', min: 0, max: 100, name: 'broker_discount', default: 20, icon: 'fas fa-percent', tooltip: 'auto', requiredIf: '$form.bookable' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'booking_notification', default: 'user', options: this._bookingNotificationOptions }),
                    new PgFormField({ label: 'auto', type: 'boolean', name: 'mandatory_email', default: false }),
                ])
            },
            'file': {
                title: null,
                description: 'auto',
                optional: true,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'info', name: 'images_rights', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'split', name: 'images_split', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images',
                        fileOptions: { 
                            imageRatio: { width: 4, height: 3 } 
                        } 
                    }),
                    new PgFormField({ label: 'auto', type: 'split', name: 'videos_split', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'videos', name: 'videos' }),
                    new PgFormField({ label: null, type: 'split', name: 'embed_split' }),
                    new PgFormField({ label: 'auto', type: 'embed', name: 'embed', tooltip: 'auto', multi: true }),
                    new PgFormField({ label: 'auto', type: 'attachment', name: 'attachments', multi: true }),
                ])
            }
        }

        return new FormFlow(_cStates);
    }

    customizeFormFlow() {
        for(let _cField of ['country','region','province','city','locality','address','zipcode','timezone']) {
            this.formFlow.states['dati_generali'].form.getFieldByName(_cField).visible = false;
        }

        this.formFlow.states['dati_generali'].form.getFieldByName('type').visible = false;

        this.formFlow.states['dati_generali'].form.getFieldLayout('poi_id').condition = '!$form.online';
        this.formFlow.states['dati_generali'].form.getFieldLayout('geolocation').condition = '!$form.online';
        this.formFlow.states['dati_generali'].form.getFieldLayout('location_description@ExperienceTranslation').condition = '!$form.online';
        this.formFlow.states['dati_generali'].form.getFieldLayout('geolocation_missing').condition = '!$form.online && !$form.poi_id && !$form.geolocation';

        this.formFlow.states['dati_generali'].form.getFieldLayout('tags').display = { fullWidth: true }

        this.formFlow.states['dati_generali'].form.getFieldByName('priority').visible = false;

        this.formFlow.states['dati_generali'].form.getFieldLayout('supplier').display = { oneLine: true }
        this.formFlow.states['dati_generali'].form.getFieldLayout('poi_id').display = { oneLine: true }

        this.formFlow.states['dati_generali'].form.getFieldByName('group_id').visible = false;
        this.formFlow.states['dati_generali'].form.getFieldByName('realm_id').visible = false;

        this.formFlow.states['descrizione'].form.getFieldLayout('parent').display = { oneLine: true }
        this.formFlow.states['descrizione'].form.getFieldLayout('tour_product_id').display = { oneLine: true }
        this.formFlow.states['descrizione'].form.getFieldLayout('tour_product_id').advanced = true;

        this.formFlow.states['descrizione'].form.getFieldLayout('subcategory').condition = '$self.options.some((element) => { return element.data.category == $form.category })';
        this.formFlow.states['descrizione'].form.getFieldLayout('secondary_categories').display = { oneLine: true }
        this.formFlow.states['descrizione'].form.getFieldByName('category_split').visible = false;
        
        this.formFlow.states['descrizione'].form.getFieldLayout('parent').condition = '$form.type == "event"';

        if(this._categoryItaliaOptions.length == 0) {
            this.formFlow.states['descrizione'].form.getFieldLayout('category_italia').hidden = true;
            this.formFlow.states['descrizione'].form.getFieldByName('category_italia').requiredIf = null;
        }
        else {
            this.formFlow.states['descrizione'].form.getFieldLayout('category_italia').condition = '$form.type == "event"';
            this.formFlow.states['descrizione'].form.getFieldByName('category_italia').requiredIf = '$form.type == "event"'
        }
        
        this.formFlow.states['disponibilita'].form.getFieldLayout('currency').display = { oneLine: true }
        this.formFlow.states['disponibilita'].form.getFieldLayout('currency').hidden = this._currencyOptions.length <= 1;

        this.formFlow.states['disponibilita'].form.getFieldLayout('booking_deadline').display = { oneLine: true }

        this.formFlow.states['disponibilita'].form.getFieldLayout('bookable').display = { fullWidth: false }

        this.formFlow.states['disponibilita'].form.getFieldLayout('booking').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('booking_notification').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('price_on_request').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('mandatory_email').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('open_event').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('maximum_participants').condition = '$form.bookable && !$form.open_event';
        this.formFlow.states['disponibilita'].form.getFieldLayout('overbooking').condition = '$form.bookable && !$form.open_event';
        this.formFlow.states['disponibilita'].form.getFieldLayout('minimum_guaranteed').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('booking_deadline').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('cancellation_deadline').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('instant_confirmation').condition = '$form.bookable';
        this.formFlow.states['disponibilita'].form.getFieldLayout('broker_discount').condition = '$form.bookable';

        this.formFlow.states['disponibilita'].form.getFieldLayout('overbooking').advanced = true;
        this.formFlow.states['disponibilita'].form.getFieldLayout('booking_deadline').advanced = true;
        this.formFlow.states['disponibilita'].form.getFieldLayout('cancellation_deadline').advanced = true;
        this.formFlow.states['disponibilita'].form.getFieldLayout('instant_confirmation').advanced = true;
        this.formFlow.states['disponibilita'].form.getFieldLayout('broker_discount').advanced = true;
        this.formFlow.states['disponibilita'].form.getFieldLayout('mandatory_email').advanced = true;      

        this.formFlow.states['disponibilita'].form.getFieldLayout('payment_not_applicable').condition = '!$form.bookable || $form.price_on_request || $form.tickets == null || tryParseJSON($form.tickets).fullPrice == null || tryParseJSON($form.tickets).fullPrice == 0';

        this.formFlow.states['disponibilita'].form.getFieldLayout('payment').condition = '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0';
        this.formFlow.states['disponibilita'].form.getFieldLayout('payment_method').condition = '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0 && $form.payment != null && tryParseJSON($form.payment).indexOf("sul_posto") != -1';
        this.formFlow.states['disponibilita'].form.getFieldLayout('iban').condition = '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0 && $form.payment != null && tryParseJSON($form.payment).indexOf("bonifico") != -1';
        this.formFlow.states['disponibilita'].form.getFieldLayout('swift').condition = '$form.bookable && !$form.price_on_request && $form.tickets != null && tryParseJSON($form.tickets).fullPrice > 0 && $form.payment != null && tryParseJSON($form.payment).indexOf("bonifico") != -1';

        this.formFlow.states['disponibilita'].form.getFieldLayout('price_on_request_from').condition = '$form.price_on_request';

        this.formFlow.states['disponibilita'].form.getFieldLayout('meeting_point').condition = '!$form.online';
        this.formFlow.states['disponibilita'].form.getFieldLayout('meeting_point_description@ExperienceTranslation').condition = '!$form.online';

        for(let _experienceType of ['activity','package','event']) {
            for(let i = 0; i < this.formFlow.states['disponibilita'].form.formGroups[0].fields.length; i++) {
                let _field = this.formFlow.states['disponibilita'].form.formGroups[0].fields[i];

                if(_field.name == 'availability_' + _experienceType) {
                    this.formFlow.states['disponibilita'].form.formGroups[0].fields.splice(i, 1)

                    this.formFlow.states['disponibilita'].form.formGroups.push(new PgFormGroup({
                        title: 'RESOURCES.' + this.resourceId + '.fields.' + _field.name + '.label',
                        description: 'RESOURCES.' + this.resourceId + '.fields.' + _field.name + '.tooltip',
                        collapsible: false,
                        fields: [_field],
                        condition: '$form.type == \'' + _experienceType + '\''
                    }))
                    break;
                }
            }
        }

        for(let i = 0; i < this.formFlow.states['disponibilita'].form.formGroups[0].fields.length; i++) {
            let _field = this.formFlow.states['disponibilita'].form.formGroups[0].fields[i];
            
            if(_field.name == 'tickets') {
                this.formFlow.states['disponibilita'].form.formGroups[0].fields.splice(i, 1)

                this.formFlow.states['disponibilita'].form.formGroups.push(new PgFormGroup({
                    title: 'RESOURCES.' + this.resourceId + '.fields.tickets.label',
                    description: 'RESOURCES.' + this.resourceId + '.fields.tickets.tooltip',
                    collapsible: false,
                    fields: [_field],
                    condition: '!$form.price_on_request',
                }))

                break;
            }
        }

        let _paymentFieldNames = ['payment_not_applicable','payment','iban','swift','payment_method'];
        let _paymentFieldList:Array<ConfigFormLayoutGroupField> = []

        for(let _fieldName of _paymentFieldNames) {
            for(let i = 0; i < this.formFlow.states['disponibilita'].form.formGroups[0].fields.length; i++) {
                let _field = this.formFlow.states['disponibilita'].form.formGroups[0].fields[i];
                
                if(_fieldName == _field.name) {
                    _paymentFieldList.push(_field)
                    this.formFlow.states['disponibilita'].form.formGroups[0].fields.splice(i, 1)
                    break;
                }
            }
        }

        this.formFlow.states['disponibilita'].form.formGroups.push(new PgFormGroup({
            title: null,
            description: null,
            collapsible: false,
            fields: _paymentFieldList
        }))

        let _fieldsList:Array<ConfigFormLayoutGroupField> = []

        while(this.formFlow.states['disponibilita'].form.formGroups[0].fields.length >= 6) { // gli altri campi a partire da qui vengono messi alla fine, vedi sopra
            _fieldsList.unshift(this.formFlow.states['disponibilita'].form.formGroups[0].fields.pop())
        }

        this.formFlow.states['disponibilita'].form.formGroups.push(new PgFormGroup({
            collapsible: false,
            fields: _fieldsList
        }))

        let _descrizioneFields = this.formFlow.states['descrizione'].form.formGroups[0].fields
        let _accessibilityFields:Array<ConfigFormLayoutGroupField> = [];

        for(let _name of ['physical_accessibility','cognitive_accessibility','blindness_accessibility','deafness_accessibility','accessibility_description@ExperienceTranslation','stroller_friendly']) {
            for(let i = 0; i < _descrizioneFields.length; i++) {
                if(_descrizioneFields[i].name == _name) {
                    _accessibilityFields.push(_descrizioneFields[i])
                    _descrizioneFields.splice(i, 1)
                    break;
                }
            }
        }

        this.formFlow.states['descrizione'].form.formGroups.push(new PgFormGroup({
            title: 'RESOURCES.' + this.resourceId + '.fields.accessibility.label',
            description: 'RESOURCES.' + this.resourceId + '.fields.accessibility.tooltip',
            collapsible: false,
            fields: _accessibilityFields
        }))

        let _disponibilitaFields = this.formFlow.states['disponibilita'].form.formGroups[this.formFlow.states['disponibilita'].form.formGroups.length - 1].fields
        let _surveyFields:Array<ConfigFormLayoutGroupField> = [];

        for(let i = 0; i < _disponibilitaFields.length; i++) {
            if(_disponibilitaFields[i].name == 'survey') {
                _surveyFields.push(_disponibilitaFields[i])
                _disponibilitaFields.splice(i, 1)
                break;
            }
        }

        this.formFlow.states['disponibilita'].form.formGroups.push(new PgFormGroup({
            title: 'RESOURCES.' + this.resourceId + '.fields.survey.label',
            description: 'RESOURCES.' + this.resourceId + '.fields.survey.tooltip',
            collapsible: false,
            fields: _surveyFields
        }))
    }

    mapImportData(data:any) {
        let _retVal = JSON.parse(JSON.stringify(data));
        return _retVal;
    }

    adaptLoadData(values:any) {
        values = super.adaptLoadData(values);

        this._lastPoi = null;
        this._lastTimezone = null;

        if(this.environmentService.environment.StripeAPIKey == null || this.environmentService.environment.StripeAPIKey == '') {
            let _cPaymentParsed = null;
            try {
                _cPaymentParsed = PGUtilities.tryParseJSON(values.payment);
            }
            catch(ex) {}
            
            if(_cPaymentParsed != null) {
                if(typeof _cPaymentParsed == 'string') {
                    if(_cPaymentParsed == 'online') {
                        values.payment = null;
                    }
                }
                else if (typeof _cPaymentParsed == 'object') {
                    let _cIndex = _cPaymentParsed.indexOf('online');
                    if(_cIndex != -1) {
                        _cPaymentParsed.splice(_cIndex, 1)
                        if(_cPaymentParsed.length == 0) {
                            values.payment = null;
                        }
                        else {
                            values.payment = JSON.stringify(_cPaymentParsed);
                        }
                    }
                }
            }
        }

        if(values.bank_transfer_method != null) {
            values.iban = values.bank_transfer_method.iban
            values.swift = values.bank_transfer_method.swift
        }

        for(let _type of ['activity','package','event']) {
            if(values.type == _type) {
                values['availability_' + _type] = values.availability
            }
            else {
                values['availability_' + _type] = null;
            }
        }

        delete values.availability;

        let _bookingNotificationString = null;
        let _bookingNotificationObject = PGUtilities.tryParseJSON(values.booking_notification)
        
        if(_bookingNotificationObject != null) {
            if(_bookingNotificationObject.user && _bookingNotificationObject.supplier) {
                _bookingNotificationString = 'both'
            }
            else if(_bookingNotificationObject.user) {
                _bookingNotificationString = 'user'
            }
            else if(_bookingNotificationObject.supplier) {
                _bookingNotificationString = 'supplier'
            }
        }

        values.booking_notification = _bookingNotificationString

        if(values.price_on_request) {
            if(values.tickets != null) {
                values.price_on_request_from = PGUtilities.tryParseJSON(values.tickets)?.fullPrice
            }
        }

        return values;
    }

    async afterInit() {
        let _id = this.elementId;
        if(this.dataService.isDraftId(_id)) _id = null;

        if(this.environmentService.getApplicationURL('Checkout') != null) {
            this.formFlow.states['disponibilita'].form.getFieldByName('booking').placeholder = this.environmentService.getApplicationURL('Checkout') + '/book-experience/' + (_id || 'id');
        }
        else {
            this.formFlow.states['disponibilita'].form.getFieldByName('booking').placeholder = null;
        }

        if(_id != null) {
            this.formFlow.states['descrizione'].form.getFieldByName('parent').optionsFilter = [{ field: 'id', operator: '!=', value: [_id] }]
        }

        if(this.viewOnly) {
            let _supplier = this.importData.supplier
            
            if(_supplier != null) {
                let _resource = _supplier.split('_')[0];
                let _element = _supplier.split('_')[1];

                await new Promise<void>((resolve) => { 
                    this.dataService.getElementData(_resource, _element).subscribe((data) => {
                        this._supplierOptions.push({ value: _supplier, text: data.id + ' - ' + data.name })
                        resolve()
                    })
                })
            }
        }

    }

    adaptSaveData(values:any) {
        values = super.adaptSaveData(values);

        if(values.online || values.poi_id != null) {
            values.coordinates = null;
            values.geolocation = null;
            values.region = null;
            values.province = null;
            values.city = null;
            values.address = null;
            values.zipcode = null;
        }

        if(values.online) {
            values.poi_id = null;
        }

        if(values.iban != null || values.swift != null) {
            values.bank_transfer_method = { iban: values.iban, swift: values.swift }
            if(typeof values.iban != 'undefined') delete values.iban;
            if(typeof values.swift != 'undefined') delete values.swift;
        }


        for(let _type of ['activity','package','event']) {
            if(values.type == _type) {
                values.availability = values['availability_' + _type];
            }

            delete values['availability_' + _type];
        }

        values.slot_duration = null;
        
        try {
            values.slot_duration = PGUtilities.tryParseJSON(values.availability)[0].slotDuration
        }
        catch(ex) {}

        if(values.booking == '') values.booking = null;

        let _bookingNotificationString = values.booking_notification;
        let _bookingNotificationObject = { user: false, supplier: false }
        
        if(_bookingNotificationString == 'both') {
            _bookingNotificationObject.user = true;
            _bookingNotificationObject.supplier = true;
        }
        else if(_bookingNotificationString == 'user') {
            _bookingNotificationObject.user = true;
        }
        else if(_bookingNotificationString == 'supplier') {
            _bookingNotificationObject.supplier = true;
        }

        values.booking_notification = _bookingNotificationObject

        if(values.price_on_request) {
            if(values.price_on_request_from) {
                values.tickets = JSON.stringify({
                    fullPrice: values.price_on_request_from,
                    otherTickets: []
                })
            }
            else values.tickets = null
        }

        return values;
    }

    private _lastPoi = null;
    private _lastPoiTimeout = null;

    onValuesChange(values) {
        super.onValuesChange(values);

        if(values.poi_id != this._lastPoi) {
            this._lastPoi = values.poi_id;
    
            values.geolocation = null;

            clearTimeout(this._lastPoiTimeout)
            this._lastPoiTimeout = setTimeout(() => { // non sono riuscito a risolvere diversamente dal mettere una setTimeout...
                if(this._lastPoi == null) {
                    this.formFlow.states.dati_generali.form.setData({ geolocation: { _forceChanges: true } })
                }
                else {
                    this.dataService.getElementData('Poi', this._lastPoi, null, 'public').subscribe((data) => {
                        values.geolocation = data.geolocation
                        values.geolocation._forceChanges = true; // ...e non sono riuscito a risolvere diversamente dal fare questo hack per triggerare la change sul campo
                        this.formFlow.states.dati_generali.form.setData(values)

                        super.onValuesChange(values);

                        this._checkTimezone(values);
                    })
                }
            }, 100)
        }
        else {
            this._checkTimezone(values);
        }
    }

    private _lastTimezone = null;

    _checkTimezone(data) {
        if(data.timezone != this._lastTimezone) {
            this._lastTimezone = data.timezone;

            this.formFlow.states.disponibilita.form.getFieldByName('availability_event').timezone = data.timezone;
            this.formFlow.states.disponibilita.form.getFieldByName('availability_package').timezone = data.timezone;
            this.formFlow.states.disponibilita.form.getFieldByName('availability_activity').timezone = data.timezone;
        }
    }

    @ViewChild('createExperienceSupplierModal') createExperienceSupplierModal:ElementRef;

    private _modalRef:NgbModalRef;

    createModalData:any = null;

    private _createSupplier() {
        this.dataService.createDraftElement('ExperienceSupplier').subscribe((data) => {
            this.createModalData = data;

            this._modalRef = this.modalService.open(this.createExperienceSupplierModal, { size: 'xl' })
        })
    }

    onCreateExperienceSupplierModalReturn(data:any) {
        this._modalRef.close();

        this.dataService.deleteDraftElement('ExperienceSupplier', this.createModalData.id).subscribe(() => {}, () => {})

        if(data.action == 'insert') {
            this._loadSupplierOptions().then(() => {
                this.formFlow.states['dati_generali'].form.setData({ supplier: 'ExperienceSupplier_' + data.id })
             }, () => { })
        }
    }

    createExperienceSupplierDismiss() {
        this._modalRef.dismiss()
    }
}

